export var channels = {
    SMS: "SMS",
    Voice: "VOICE",
    Email: "EMAIL",
    "Virtual Receptionist": "IVR",
    Bot: "BOT",
    Ip: "IP",
    Ussd: "USSD",
    Mms: "MMS",
    WhatsApp: "WHATSAPP",
    RCS: "RCS",
};
export var channelConstants = {
    ALL_CHANNEL: "All Channels",
    SMS: "SMS",
    EMAIL: "Email",
    WHATSAPP: "WhatsApp",
    VOICE: "Voice",
    RCS: "RCS",
    VIRTUAL_RECEPTIONIST: "Virtual Receptionist",
    NETWORK: "Network",
};
export var category = {
    All: "",
    Promotional: 0,
    Transactional: 1,
    OTP: 2,
    Incoming: "inbound",
    Outgoing: "outbound",
    Marketing: 9,
    Utility: 10,
    Authentication: 11,
    Service: 12,
    Basic: "0",
    Single: "1",
    Conversational: "2",
    Conversation: "2",
};
export var templateTypeCat = {
    All: "1,2,3",
    Text: 1,
    "Media & Interactive": 2,
    Carousel: 3,
};
export var distributionCat = {
    All: "",
    Authentication: "AUTHENTICATION",
    Marketing: "MARKETING",
    Utility: "UTILITY",
};
export var whatAppBusinessAcctNumStatus = {
    CONNECTED: "CONNECTED",
    PENDING_APPROVAL: "PENDING_APPROVAL",
    PENDING_ISSUE: "PENDING_ISSUE",
};
export var sortFormMonths = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
];
export var callOption = {
    all: "",
    All: "",
    Call: "call",
    "Open URL": "url",
    "Calendar Event": "calendar",
    "Share Location": "location",
    "View Location": "map",
    "Add Text": "reply",
};
